import { Box } from "@mui/material"

export const ObservationDetail = () => {
    return (
        <Box>
            detail
        </Box>
    )
}